export default __webpack_public_path__ + "static/media/categorie_sante.5c0042f0.jpg";